module.exports = __webpack_public_path__ + "media/images/emotional-intelligence-template-d3f326712c8135b5b4a801c18a7e8a0d.jpg";